import { useOutletContext } from 'react-router-dom';
import type { OrgAdminOrganization } from '@dermalink/shared';

export interface PracticeAdminContext {
  organizations: OrgAdminOrganization[];
  org:           OrgAdminOrganization;
  selectOrg:     (id: number) => void;
}

export function usePracticeAdmin() {
  return useOutletContext<PracticeAdminContext>();
}
